import { NgModule } from '@angular/core';

import { SharedModule } from '../shared/shared.module';
import { AdminFooterComponent } from './admin/admin-footer/admin-footer.component';
import { AdminHeaderComponent } from './admin/admin-header/admin-header.component';
import { AdminMenuitemComponent } from './admin/admin-menuitem/admin-menuitem.component';
import { AdminShellComponent } from './admin/admin-shell/admin-shell.component';
import { AdminSidebarComponent } from './admin/admin-sidebar/admin-sidebar.component';
import { AuthShellComponent } from './auth/auth-shell/auth-shell.component';
import { ProfileMenuComponent } from './profile-menu/profile-menu.component';
import { BusinessExitComponent } from './admin/business-exit/business-exit.component';
import { ThemeSectionComponent } from './admin/theme-section/theme-section.component';

@NgModule({
    declarations: [
        AdminShellComponent,
        AdminHeaderComponent,
        AdminSidebarComponent,
        AdminMenuitemComponent,
        AdminFooterComponent,
        ProfileMenuComponent,
        BusinessExitComponent,
        ThemeSectionComponent,
        AuthShellComponent,
    ],
    imports: [SharedModule],
    exports: [AdminShellComponent, AuthShellComponent],
})
export class LayoutModule {}
